const keywords = [
  'Function',
  'String\\.fromCharCode',
  'constructor',
  'eval',
  'getPrototypeOf',
  'global',
  'node_modules',
  'process',
  'prototype',
  'setInterval',
  'setTimeout'
];

export default function isContainingRestrictedKeywords(code) {
  if (code == null) return;

  // Remove comments
  code = code.replace(/\/\*[\s\S]*?\*\/|([^:]|^)\/\/.*$/gm, '');

  const regexes = [
    new RegExp('\\b(' + keywords.join('|') + ')\\b'),
    new RegExp(/require\s*\(\s*["'](?:fs|child_process|aws-sdk)["']\s*\)/),
    new RegExp(/0x/)
  ];

  for (const regex of regexes) {
    const match = regex.exec(code);
    if (match) {
      const startIndex = Math.max(match.index - 20, 0);
      const endIndex = Math.min(match.index + match[0].length + 20, code.length);

      const detectedCode = code.substring(startIndex, endIndex);

      return { match: match[0], detectedCode };
    }
  }
}
